<div class="simple-chip" [attr.role]="single ? null : 'listitem'">
  <div>
    <span aria-hidden="true"><i class="wbsuche-icon {{ icon }}"></i></span>
    @if (name) {
      <span class="sr-only">{{ name }}</span>
    }
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
